import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { UserService } from "../_services/user.service";
import { Observable } from "rxjs/Rx";

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private _router: Router, private _userService: UserService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        let currentUser = JSON.parse(localStorage.getItem('currentUser'));
        console.log("canActivate");

        console.log(state.root.queryParams);

        var token = state.root.queryParams.token;
        var athlete_id = state.root.queryParams.athlete_id;

        if (token && athlete_id) {
            var url_string = window.location.href
            var url = new URL(url_string);
            var pathname = window.location.pathname;

            var data: any = {};
            data.token = token;
            data.athlete_id = athlete_id;
            data = JSON.stringify(data);

            return this._userService.checkParentAppAthlete(token, athlete_id);

        }




        return this._userService.verify().map(
            data => {
                if (data !== null) {
                    // logged in so return true
                    console.log("data beep");
                    return true;
                }

                console.log("error beep");

                // error when verify so redirect to login page with the return url
                this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                return false;
            },
            error => {
                console.log("error boop");
                // error when verify so redirect to login page with the return url
                this._router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
                return false;
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/auth/_guards/auth.guard.ts